import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { PageShell } from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import UPVC from "./pages/UPVC";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import AllReviews from "./pages/AllReviews";
import AdminGallery from "./pages/AdminGallery";

function App() {
  return (
    <div className="App">
      <Toaster richColors position="top-right" />
      <BrowserRouter>
        <PageShell>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/upvc" element={<UPVC />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/reviews" element={<AllReviews />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin/gallery" element={<AdminGallery />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </PageShell>
      </BrowserRouter>
    </div>
  );
}

export default App;
